import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filterConsents } from '@icc/b2b/shared';
import { ConfigService } from '@icc/shared';

export const ConsentGuard: CanActivateFn = (route, state) => {
    const configService = inject(ConfigService);
    const router: Router = inject(Router);
    const isSublicense = configService.user?.user?.ActiveCompanyLicenseType === 'sublicense';
    if (!isSublicense) {
        return true;
    }
    const hasUnacceptedConsents = configService.user?.consents?.length
        && filterConsents(configService.user.consents, configService.user.acceptedConsents).length;
    const hasUnacceptedSingleConsent = configService.config.config.User.allowOutsideRegister
        && configService.user?.consent?.img
        && !configService.user.acceptedConsents.some(
            (acceptedConsent) => acceptedConsent.consentId === configService.user.consent.id
        );
    if (hasUnacceptedConsents || hasUnacceptedSingleConsent) {
        return router.navigate(['consent']);
    }
    return true;
};
